import React, { useEffect, useMemo, useRef, useState } from "react";

const ViewModeSelect = ({
  value,
  onChange, // (newValue) => void
  className = "mt-4 col-sm-4",
  label = "VIEW MODE",
  placeholder = "Select view",
  disabled = false,
  icon = "bi bi-sliders",
  options = [
    { value: "top5", label: "Top 5 Products Customers Buy" },
    { value: "breakdown", label: "Customer Breakdown" },
  ],
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selected = useMemo(
    () => options.find((o) => o.value === value),
    [options, value],
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (newValue) => {
    onChange?.(newValue);
    setIsOpen(false);
  };

  return (
    <div className={className}>
      {label && (
        <label
          style={{
            fontSize: "0.75rem",
            fontWeight: 700,
            color: "#6b7280",
            marginBottom: 6,
            display: "block",
            letterSpacing: 0.4,
          }}
        >
          {label}
        </label>
      )}

      <div ref={dropdownRef} style={{ position: "relative" }}>
        {/* Button */}
        <button
          type="button"
          disabled={disabled}
          onClick={() => !disabled && setIsOpen((v) => !v)}
          style={{
            width: "100%",
            height: 46,
            borderRadius: 14,
            border: isOpen ? "2px solid #1F4D2C" : "1px solid #e5e7eb",
            background: disabled ? "#f9fafb" : "#ffffff",
            boxShadow: isOpen
              ? "0 0 0 3px rgba(31,77,44,0.12)"
              : "0 6px 16px rgba(0,0,0,0.06)",
            padding: "0 14px 0 44px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: disabled ? "not-allowed" : "pointer",
            transition: "all 0.18s ease",
            fontWeight: 700,
            fontSize: "0.92rem",
            color: selected ? "#111827" : "#9ca3af",
          }}
        >
          {/* Left icon */}
          <i
            className={icon}
            style={{
              position: "absolute",
              left: 14,
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: 16,
              color: disabled ? "#d1d5db" : "#6b7280",
              pointerEvents: "none",
            }}
          />

          <span style={{ textAlign: "left" }}>
            {selected ? selected.label : placeholder}
          </span>

          {/* Right chevron */}
          <i
            className={`bi ${isOpen ? "bi-chevron-up" : "bi-chevron-down"}`}
            style={{
              fontSize: 14,
              color: disabled ? "#d1d5db" : "#9ca3af",
              marginLeft: 12,
            }}
          />
        </button>

        {/* Dropdown panel */}
        {isOpen && (
          <div
            style={{
              position: "absolute",
              top: "calc(100% + 8px)",
              left: 0,
              right: 0,
              background: "#ffffff",
              borderRadius: 16,
              border: "1px solid #e5e7eb",
              boxShadow:
                "0 20px 25px -5px rgba(0,0,0,0.12), 0 10px 10px -5px rgba(0,0,0,0.06)",
              overflow: "hidden",
              zIndex: 2000,
            }}
          >
            {/* “All / Placeholder” style header (optional) */}
            <div
              style={{
                padding: "14px 16px",
                borderBottom: "1px solid #f3f4f6",
              }}
            >
              <div style={{ fontWeight: 700, fontSize: 15, color: "#374151" }}>
                Select Option
              </div>
              <div style={{ fontSize: 10, color: "#9ca3af", marginTop: 2 }}>
                Choose what you want to display
              </div>
            </div>

            {/* Options list */}
            <div
              style={{
                maxHeight: 320,
                overflowY: "auto",
                padding: 10,
              }}
            >
              {options.map((opt) => {
                const isSelected = opt.value === value;

                return (
                  <div
                    key={opt.value}
                    onClick={() => handleSelect(opt.value)}
                    style={{
                      padding: "16px 14px",
                      borderRadius: 14,
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      fontSize: 14,
                      fontWeight: 800,
                      color: isSelected ? "#1F4D2C" : "#374151",
                      background: isSelected
                        ? "rgba(31,77,44,0.08)"
                        : "transparent",
                      transition: "all 0.12s ease",
                    }}
                    onMouseEnter={(e) => {
                      if (!isSelected)
                        e.currentTarget.style.background =
                          "rgba(17,24,39,0.04)";
                    }}
                    onMouseLeave={(e) => {
                      if (!isSelected)
                        e.currentTarget.style.background = "transparent";
                    }}
                  >
                    <span>{opt.label}</span>

                    {isSelected && (
                      <span
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: 999,
                          background: "rgba(31,77,44,0.12)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#1F4D2C",
                        }}
                      >
                        <i className="bi bi-check-lg" />
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewModeSelect;
